import React from 'react'
import styled, { withTheme } from 'styled-components'
import { Tooltip, PieChart, Pie, Cell, Legend, ResponsiveContainer } from 'recharts'
import { Value } from 'libreact/lib/Value'
import ActiveShape from './ActiveShape'
import Label from './Label'
import CustomTooltip from './CustomTooltip'
import CustomLegend from './CustomLegend'
import totalCostsByCategory from '../../../../calculations/totalCosts/byCategory'

const ChartContainer = styled.div`
  padding-top: 30px;
`

const CHART_COLORS = theme => ([
  theme.colors.green,
  theme.colors.blue,
  theme.colors.yellow,
  theme.colors.orange,
  theme.colors.lightBlue,
])

const color = (theme, index) => CHART_COLORS(theme)[index]

export default withTheme(({ form, theme }) => (
  <ChartContainer>
    <Value init={0}>
      {({ value, set }) => (
        <ResponsiveContainer height={500} width='100%'>
          <PieChart key='pieChart'>
            <Pie
              data={totalCostsByCategory(form)}
              dataKey='value'
              nameKey='label'
              label={<Label theme={theme} />}
              labelLine={false}
              activeShape={<ActiveShape theme={theme} />}
              activeIndex={value}
              onMouseEnter={(data, index) => set(index)}
              isAnimationActive={false}
            >
              {totalCostsByCategory(form).map((entry, index) => (
                <Cell key={index} fill={color(theme, index)}/>)
              )}
            </Pie>
            <Tooltip content={<CustomTooltip />} />
            <Legend content={<CustomLegend />} />
          </PieChart>
        </ResponsiveContainer>
      )}
    </Value>
  </ChartContainer>
))
